import RefreshIcon from '@mui/icons-material/Refresh';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useSession } from '../session/session';

/** How often a live figure is read again while its page is visible. */
export const LIVE_REFRESH_MS = 60_000;

/**
 * Query options for a figure that keeps itself current: read again every minute while the page is
 * visible, not while the tab is hidden (TanStack Query pauses the interval in the background).
 */
export const LIVE_QUERY = {
  refetchInterval: LIVE_REFRESH_MS,
  refetchIntervalInBackground: false,
} as const;

/** When the figures were last read, in the business time zone, and a way to read them now. */
export function LiveStatus({
  updatedAt,
  refreshing,
  onRefresh,
}: {
  /** Milliseconds since the epoch; 0 before the first read. */
  updatedAt: number;
  refreshing: boolean;
  onRefresh: () => void;
}) {
  const session = useSession();
  const time =
    updatedAt === 0
      ? null
      : new Intl.DateTimeFormat('en-GB', {
          timeZone: session.data?.businessTimezone ?? 'Asia/Dubai',
          hour: '2-digit',
          minute: '2-digit',
        }).format(new Date(updatedAt));
  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
      <Typography variant="caption" color="text.secondary" role="status" aria-live="polite">
        {refreshing ? 'Updating…' : time === null ? '' : `Updated ${time} · refreshes every minute`}
      </Typography>
      <Button size="small" startIcon={<RefreshIcon />} disabled={refreshing} onClick={onRefresh}>
        Refresh
      </Button>
    </Stack>
  );
}
